<template>
    <span>
        <template v-if="$store.getters.getPackage != 'premium' && value">
            <span class="label label-info">PREMIUM</span>
        </template>
        <template v-else-if="$store.getters.getPackage == 'premium' && value">
            <slot></slot>
        </template>
        <template v-else>-</template>
    </span>
    
</template>

<script>
    export default {
        props: ['value']
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerItemValue.vue